export default "__VITE_ASSET__a7ec5f18__"